import { IFundraiser } from '@models/fundraiser.model';

export const SUPPORTED_UTMS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'utm_placement'
] as const;

export type TSupportedUtms = typeof SUPPORTED_UTMS[number];

export interface IUTMs {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_content?: string;
  utm_placement?: string;
}

export interface IEventFundraiser {
  access_url: string;
  address_1: string;
  address_2: string;
  address_3: string;
  age: string;
  city: string;
  disable_foreign_donation: number;
  display_type: string;
  email: string;
  entity_type: string;
  extension: string;
  fname: string;
  full_name: string;
  gender: string;
  id: number;
  is_subscribed: number;
  last_communication_date: string;
  lname: string;
  phone_1: string;
  phone_2: string;
  pincode: string;
  priority: string;
  raised: {
    backers: number;
    event_entity_details_id: number;
    raised: number;
    matched: number;
    matchremaining: number;
  };
  status_flag: number;
  updation_time: string;
  user_details_id: number;
  user_role: string;
  username: string;
  website_1: string;
  website_2: string;
}


export interface IEventCause {
  campaigns: IFundraiser[];
  causes: ICause[];
}

export interface ICause {
  id: number;
  info_1: string;
  info_2: string;
  info_3: string;
  info_4: string;
  parent_cause_id: number;
  raise: {
    cause_id: number;
    raised: number;
    served: number;
  };
  status_flag: number;
}
